import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Box,
} from "@mui/material";

// Popup shown when some assets have no sticker size.
// The user picks a size; optionally it is saved on those assets.
const PrintSizeModal = ({
  open,
  missingAssets = [],
  missingCount = 0,
  sizeOptions = [],
  onCancel,
  onConfirm,
}) => {
  const [sizeId, setSizeId] = useState("");
  const [saveSize, setSaveSize] = useState(true);

  useEffect(() => {
    if (open) {
      setSizeId("");
      setSaveSize(true);
    }
  }, [open]);

  // Only asset sticker sizes (not warehouse sizes)
  const options = (sizeOptions || []).filter((o) => Number(o.is_warehouse || 0) !== 1);
  const total = missingCount || missingAssets.length;
  const hiddenCount = total - missingAssets.length;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Choose sticker size</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: "0.9rem", color: "#555", mb: 1 }}>
          {total === 1
            ? "This asset has no sticker size:"
            : `These ${total} assets have no sticker size:`}
        </Typography>
        <Box
          sx={{
            maxHeight: 160,
            overflowY: "auto",
            backgroundColor: "#fafafa",
            border: "1px solid #eee",
            borderRadius: "6px",
            p: "6px 12px",
            mb: 2,
          }}
        >
          {missingAssets.map((a) => (
            <Typography key={a.asset_id} sx={{ fontSize: "0.85rem" }}>
              • {a.asset_id}
              {a.category ? <span style={{ color: "#777" }}> ({a.category})</span> : null}
            </Typography>
          ))}
          {hiddenCount > 0 && (
            <Typography sx={{ fontSize: "0.85rem", color: "#777" }}>
              … and {hiddenCount} more
            </Typography>
          )}
        </Box>

        <TextField
          select
          fullWidth
          size="small"
          label="Size *"
          value={sizeId}
          onChange={(e) => setSizeId(e.target.value)}
        >
          {options.map((o) => (
            <MenuItem key={o.id} value={o.id}>
              {o.size}
            </MenuItem>
          ))}
        </TextField>

        <FormControlLabel
          sx={{ mt: 1 }}
          control={
            <Checkbox
              checked={saveSize}
              onChange={(e) => setSaveSize(e.target.checked)}
              color="success"
            />
          }
          label={
            <Box>
              <Typography sx={{ fontSize: "0.9rem" }}>Save this size for these assets</Typography>
              <Typography sx={{ fontSize: "0.75rem", color: "#777" }}>
                So you are not asked again next time
              </Typography>
            </Box>
          }
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="success"
          disabled={!sizeId}
          onClick={() => onConfirm(sizeId, saveSize)}
        >
          Print
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrintSizeModal;